export interface DungeonRoom {
  id: string;
  name: string;
  purpose: string;
  zone: number;
  x: number;
  y: number;
  width: number;
  height: number;
  description: string;
  atmosphere: string;
  secrets: string;
  metadata?: Record<string, unknown>;
}

export interface DungeonCorridor {
  id: string;
  fromRoomId: string;
  toRoomId: string;
  cells: { x: number; y: number }[];
  doorType?: 'door' | 'locked' | 'hidden' | 'gate' | null;
}

export interface DungeonEntity {
  id: string;
  roomId: string;
  catalogEntryId?: string;
  type: 'monster' | 'npc' | 'object';
  name: string;
  icon: string;
  x: number;
  y: number;
  metadata?: Record<string, unknown>;
}

export interface DungeonTrigger {
  id: string;
  roomId?: string;
  name: string;
  condition: 'step' | 'proximity' | 'visible' | 'interact';
  targetX?: number;
  targetY?: number;
  targetEntityId?: string;
  effect: 'dialogue' | 'combat' | 'trap' | 'teleport' | 'spawn' | 'custom';
  effectData: Record<string, unknown>;
  requiredFlags: string[];
  setsFlag?: string;
  oneShot: boolean;
  metadata?: Record<string, unknown>;
}

export interface DungeonQuest {
  id: string;
  name: string;
  description: string;
  type: 'main' | 'optional' | 'hidden';
  completionFlag: string;
  dependsOn: string[];
  order: number;
  metadata?: Record<string, unknown>;
}

export interface DungeonMapData {
  gridWidth: number;
  gridHeight: number;
  rooms: DungeonRoom[];
  corridors: DungeonCorridor[];
  entities: DungeonEntity[];
  triggers: DungeonTrigger[];
  quests: DungeonQuest[];
}

export interface MonsterCatalogEntry {
  id: string;
  name: string;
  icon: string;
  difficulty: number;
  description: string;
  combatDescription: string;
  tags: string[];
  hp: number;
  resolve: number;
  attacks: { name: string; damage: number; description: string }[];
  spells: { name: string; cost: number; description: string }[];
  loot: string[];
}

export function createEmptyMapData(gridWidth: number, gridHeight: number): DungeonMapData {
  return {
    gridWidth,
    gridHeight,
    rooms: [],
    corridors: [],
    entities: [],
    triggers: [],
    quests: [],
  };
}
